import { Dot, HelpPopover } from "@components"
import PropTypes from "prop-types"

const Group = ({
  id,
  title, 
  absent = 0,
  attended = 0, 
  available = 0,
  booked = 0, 
  disabled = 0 
}) => (
  <div className="timetable-group__title">
    {title}

    <HelpPopover id={id} color="text-indigo-200" hoverColor="text-indigo-400">
      <p className="mb-3 text-lg font-semibold">{title}</p> 
      
      <div className="flex flex-col w-full gap-1">
        <p className="mb-1 font-semibold text-md">Slot Summary</p>
        <Dot color="available" text={`${available} Available`} textColor="text-white" />
        <Dot color="booking" text={`${booked} Booked`} textColor="text-white" />
        <Dot color="disabled" text={`${disabled} Disabled`} textColor="text-white" />
        <Dot color="absent" text={`${absent} Absent`} textColor="text-white" />
        <Dot color="attended" text={`${attended} Attended`} textColor="text-white" />
      </div>
    </HelpPopover>    
  </div>
)

Group.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  absent: PropTypes.number,
  attended: PropTypes.number,
  available: PropTypes.number,
  booked: PropTypes.number,
  disabled: PropTypes.number,
}

export default Group